export default __webpack_public_path__ + "static/media/my-pic.7e4e82d0.png";